import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { EmbeddedSearchPageContainerComponent } from '../../../overviews/search-page/containers/embedded-search-page/embedded-search-page.container.component';
import { ShRecordTreePanelContainerComponent } from '../../../POCs/pim/containers/record-tree-panel/record-tree-panel-container.component';
import { ShProfileFacetListContainerComponent } from '../../../profile-facets/containers/profile-facet-list/profile-facet-list-container.component';
import { RecordSearchPageSandbox } from '../../sandboxes/record-search-page.sandbox';
import { RecordSearchPageContainerComponent } from '../record-search-page/record-search-page.container.component';

@Component({
    standalone: true,
    selector: 'sh-embedded-record-search-page',
    templateUrl: './embedded-record-search-page.container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        RouterModule,
        ShProfileFacetListContainerComponent,
        EmbeddedSearchPageContainerComponent,
        ShRecordTreePanelContainerComponent
    ],
    providers: [RecordSearchPageSandbox]
})
export class EmbeddedRecordSearchPageContainerComponent extends RecordSearchPageContainerComponent {}
